import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bool, shape, func } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomData from "pages/_components/CustomData/CustomData";
import EcheqCheckbox from "pages/discounts/DiscountCreation/components/EcheqCheckbox";

import { isIOS } from "react-device-detect";

const PaymentDueListItem = ({ data, isDesktop, onChange, isConfirmPage }) => {
    const [check, setCheck] = useState(false);

    useEffect(() => {
        setCheck(false);
    }, [data]);

    const getPeriod = (dueDate) => {
        const date = dueDate.split("T")[0];
        const aux = date.split("-");
        return `${aux[1]}/${aux[2]}`;
    };

    const handleSelect = (id, value) => {
        setCheck(value);
        onChange(id, value);
    };

    return (
        <GridTable.Container columns={5} renderAs="div" className={isIOS ? "mb-5 gap-5" : "gap-5"}>
            {!isConfirmPage && (
                <GridTable.Data columnStart={1} rowStart={1}>
                    <EcheqCheckbox
                        key={data.debtId}
                        name={data.id}
                        checked={check}
                        onChange={(value) => handleSelect(data.id, value)}
                    />
                </GridTable.Data>
            )}
            <GridTable.Data
                key={1}
                columnStart={isDesktop ? 2 : 1}
                rowStart={isDesktop ? 1 : 2}
                alignX="flex-start"
                alignY="flex-start">
                <CustomData
                    titleText="afip.services.payment.schedule.concept"
                    titleTextType="I18N"
                    valueText={data?.conceptDescription}
                />
            </GridTable.Data>
            <GridTable.Data
                key={2}
                columnStart={isDesktop ? 3 : 1}
                rowStart={isDesktop ? 1 : 3}
                alignX="flex-start"
                alignY="flex-start">
                <CustomData
                    titleTextType="I18N"
                    titleText="afip.services.payment.schedule.dueDate"
                    valueTextType="DATE"
                    valueText={data?.dueDate}
                />
            </GridTable.Data>
            <GridTable.Data
                key={3}
                columnStart={isDesktop ? 4 : 1}
                rowStart={isDesktop ? 1 : 4}
                alignX="flex-start"
                alignY="flex-start">
                <CustomData
                    titleText="afip.services.payment.schedule.period"
                    titleTextType="I18N"
                    valueText={getPeriod(data?.dueDate)}
                />
            </GridTable.Data>
            <GridTable.Data
                key={4}
                columnStart={isDesktop ? 5 : 1}
                rowStart={isDesktop ? 1 : 5}
                alignX="flex-start"
                alignY="flex-start">
                <CustomData
                    titleText="afip.services.payment.schedule.amount"
                    titleTextType="I18N"
                    valueText={data?.amount}
                    valueTextType="ARS"
                />
            </GridTable.Data>
        </GridTable.Container>
    );
};

PaymentDueListItem.propTypes = {
    data: shape({}).isRequired,
    isDesktop: bool.isRequired,
    onChange: func.isRequired,
    isConfirmPage: bool,
};

PaymentDueListItem.defaultProps = {
    isConfirmPage: false,
};

export default connect()(PaymentDueListItem);
